export const loadGoogleMapsScript = (callback) => {
    const runWhenReady = () => {
        if (window.google && window.google.maps && window.google.maps.Map) {
            if (callback) callback();
            return;
        }

        let attempts = 0;
        const maxAttempts = 100;
        const poll = window.setInterval(() => {
            if (window.google && window.google.maps && window.google.maps.Map) {
                window.clearInterval(poll);
                if (callback) callback();
                return;
            }

            attempts += 1;
            if (attempts >= maxAttempts) {
                window.clearInterval(poll);
            }
        }, 100);
    };

    if (window.google && window.google.maps && window.google.maps.Map) {
        runWhenReady();
        return;
    }

    const existingScript = document.getElementById('google-maps-sdk');

    if (!existingScript) {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?loading=async&key=AIzaSyDrsR6tJqpBFXQkjQmKDCYP6Ig6eQwZCZI&libraries=places`;
        script.id = 'google-maps-sdk';
        script.async = true;
        script.defer = true;
        script.onload = () => {
            script.dataset.loaded = 'true';
            runWhenReady();
        };
        document.body.appendChild(script);
    } else {
        if (existingScript.dataset.loaded === 'true' || (window.google && window.google.maps && window.google.maps.Map)) {
            runWhenReady();
            return;
        }

        existingScript.addEventListener('load', () => {
            existingScript.dataset.loaded = 'true';
            runWhenReady();
        }, { once: true });
    }
};
